<template>
  <nuttrema-layout-form-standard :edit="true" theme="west-top">
    <template slot="center">
      <el-form
         label-position="top"
        :ref="formRef"
        :model="formData"
        :validate-on-rule-change="false"
        :rules="rules">

        <section>
          <p class="section-title">{{ $t('label.options') }}</p>
          <div class="section-items">

            <el-popover
             ref="ref-invite-multiple-popover"
             placement="right"
             trigger="hover"
             width="380"
             popper-class="el-popover--options"
            :title="$t('label.email_list_help_title')"
            :open-delay="500">
              <div class="el-popover__content">
                <p>{{ $t('label.email_list_help_sample_01') }}</p>
                <p>{{ $t('label.email_list_help_sample_02') }}</p>
                <p>{{ $t('label.email_list_help_sample_03') }}</p>
                <p>{{ $t('label.email_list_help_sample_04') }}</p>
                <p>{{ $t('label.email_list_help_sample_05') }}</p>
              </div>
            </el-popover>

            <el-form-item v-show="options.inviteMultiple" prop="invitees" class="el-form-item__label--is-description">
              <template slot="label">
                {{ $t('label.email_invitations_list') }}
                <a v-popover:ref-invite-multiple-popover>{{ $t('label.email_list_help_link') }}</a>
              </template>
              <el-input
                 type="textarea"
                 v-model="formData.invitees"
                :autosize="{ minRows: 6, maxRows: 12 }">
              </el-input>
            </el-form-item>


            <el-form-item v-show="!options.inviteMultiple" :label="$t('label.name')" prop="name">
              <el-input v-model="formData.name" :placeholder="$t('label.first_and_last_name')"></el-input>
            </el-form-item>

            <el-form-item v-show="!options.inviteMultiple" :label="$t('label.email')" prop="email">
              <el-input v-model="formData.email"></el-input>
            </el-form-item>

            <el-form-item :label="$t('label.custom_message')" prop="custom_message">
              <el-input
                 type="textarea"
                 v-model="formData.message"
                :autosize="{ minRows: 3, maxRows: 10 }">
              </el-input>
            </el-form-item>

            <el-form-item :label="$t('label.invite_multiple')" class="is-inline">
              <el-switch v-model="options.inviteMultiple"></el-switch>
            </el-form-item>

          </div>
        </section>

      </el-form>
    </template>

    <template slot="footer">
      <nav class="footer-row">
        <el-button type="primary" size="small" :loading="isSaving" @click="submitForm">{{ $t('label.send_invite') }}</el-button>
        <el-button type="text" size="small" @click="cancelChanges">{{ $t('label.cancel') }}</el-button>
      </nav>
    </template>

  </nuttrema-layout-form-standard>
</template>

<script>
import { each } from 'lodash';
import { validateEmailRFC822 } from 'helpers/validation-helper';
import NuttremaLayoutFormStandard from 'components/ui/layout/nuttrema-layout-form-standard';
import FormStandardBehavior from 'src/components/mixins/form-standard-behavior';

export default {
  name: 'form-send-invite',
  mixins: [
    FormStandardBehavior,
  ],
  props: {
    type: {
      type: String,
      required: true,
      default: null,
    },
    InvitationDetails: {
      required: true,
      default: null,
    },
  },
  components: {
    NuttremaLayoutFormStandard,
  },
  data() {
    return {
      options: {
        inviteMultiple: false,
      },
      payload: {
        invitees: [],
        scopes: null,
        message: null,
        invitation_type: null,
      },
      formData: {
        name: null,
        email: null,
        message: null,
        invitees: null,
      },
    };
  },
  computed: {
    rules() {
      return {
        name: [
          {
            required: !this.options.inviteMultiple,
            message: this.formatValidationMessage('validation.required', 'label.first_and_last_name', true),
            trigger: 'blur',
          },
        ],
        email: [
          {
            required: !this.options.inviteMultiple,
            message: this.formatValidationMessage('validation.required', 'label.email', true),
            trigger: 'blur',
          },
          {
            type: 'email',
            message: this.formatValidationMessage('validation.invalid', 'label.email', true),
            trigger: 'blur',
          },
        ],
        invitees: [
          {
            required: this.options.inviteMultiple,
            message: this.formatValidationMessage('validation.required', 'label.email_list', true),
            trigger: 'blur',
          },
          {
            validator: this.options.inviteMultiple ? this.validateInvitees : null,
            message: this.formatValidationMessage('validation.invalid', 'label.email_list', true),
            trigger: 'blur',
          },
        ],
      };
    },
  },
  methods: {
    validateInvitees(rule, value, callback) {
      if (!validateEmailRFC822(value)) return callback(new Error());
      return callback();
    },
    setFormData() {
      this.payload.invitation_type = this.type;
    },
    getFormData() {
      if (this.options.inviteMultiple) {
        if (this.formData.invitees.indexOf(',') !== -1) {
          const list = this.formData.invitees.split(',');
          each(list, (item) => {
            const email = item.trim().replace(/[\n\r\t]/g, '');
            this.payload.invitees.push(email);
          });
        } else {
          this.payload.invitees.push(this.formData.invitees);
        }
      } else {
        this.payload.invitees.push(`${this.formData.name} <${this.formData.email}>`);
      }

      this.payload.message = this.formData.message;

      return this.removeEmpty(this.payload);
    },
  },
  created() {
    this.formRef = 'form-send-invite';
    this.stateData = this.InvitationDetails;
    this.setFormData();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/persons/invitations/send-invite/form-send-invite.vue